import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpModule } from '../http/http.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoggerListenerService } from './services/logger-listener.service';
import { LoggerHandlerService } from './services/logger-handler.service';
import { LoggerService } from './services/logger.service';
import { HttpServiceLogInterceptor } from './interceptors/http-service.log.interceptor';
import { LoggerHelperService } from './services/logger-helper.service';
import { LOGS_URL } from './constants/consts'
import { RoutingModule } from '../routing/routing.module';
import { InitializerModule } from '../initializer/initializer.module';




@NgModule({
    imports: [
        InitializerModule,
        HttpModule,
        RoutingModule.forRoot()
    ],
    declarations: [],
    providers:
        [
            LoggerListenerService,
            LoggerHandlerService,
            LoggerService,
            LoggerHelperService,
            {
                provide: HTTP_INTERCEPTORS,
                useClass: HttpServiceLogInterceptor,
                multi: true,
            }
        ],
    exports: []
})
export class LoggingModule {
    static forRoot(logsUrl: string): ModuleWithProviders<LoggingModule> {
        return {
            ngModule: LoggingModule,
            providers: [
                {
                    provide: LOGS_URL,
                    useValue: logsUrl
                }
            ]
        }
    }

}
